import { Navigate, Route, Routes } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { SettingsSectionLayout } from '../../../components/Layout/Layout';

import { ConditionFormsRoutes } from './subsections/ConditionForms/ConditionForms';
import { WorkflowsRoutes } from './subsections/Workflows/Workflows';

export const Workflows = () => {
  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.workflows">Workflows</Trans>}
      tabs={[
        {
          id: 'workflows',
          label: <Trans id="settings.organization.workflows.workflows">Workflows</Trans>,
        },
        {
          id: 'condition-forms',
          label: (
            <Trans id="settings.organization.data-catalogs.condition-forms">Condition forms</Trans>
          ),
        },
      ]}
    >
      <Routes>
        <Route path="workflows/*" element={<WorkflowsRoutes />} />
        <Route path="condition-forms/*" element={<ConditionFormsRoutes />} />
        <Route path="*" element={<Navigate to="/settings_beta/workflows/workflows" replace />} />
      </Routes>
    </SettingsSectionLayout>
  );
};
